import { BN } from 'bn.js';
import { addAddressPadding, encode } from 'starknet';

export function getAccountAddressFromId(walletAddress: string, accountId: number) {
  const hexWalletAddress = new BN(addAddressPadding(walletAddress).slice(2), 'hex');
  const accountAddress = hexWalletAddress.xor(new BN(accountId));

  return encode.addHexPrefix(encode.removeHexPrefix(accountAddress.toString('hex')).padStart(64, '0'));
}
